import { NgModule } from '@angular/core';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SharedModule } from '../shared.module';

@NgModule({
  declarations: [
    FileUploadComponent,
    BreadcrumbComponent,
  ],
  imports: [
      SharedModule,
  ],
  exports: [
      FileUploadComponent,
     BreadcrumbComponent],
})
export class ComponentsModule {}
